<span class="text-sm font-normal text-widget sm:text-xs">
    @if (propertyValue == '') {
        {{ value }}
    } @else {
        {{ propertyValue | translate }}
    }
</span>


